import { useTranslation } from 'react-i18next';
import type { PreVisitQuestion } from '@/api/preVisit/preVisitApi.types';
import { resolveLocalizedText } from '@/utils/localizedText';

interface SectionHeadingRendererProps {
  question: PreVisitQuestion;
}

export function SectionHeadingRenderer({ question }: SectionHeadingRendererProps) {
  const { i18n } = useTranslation('intake');
  const label = resolveLocalizedText(question.labelEn, question.labelPl, i18n.language);

  return (
    <p className="text-xs font-bold uppercase tracking-wider text-zoomuted pt-2 first:pt-0">
      {label}
    </p>
  );
}
